module.exports = "/_next/static/images/react_india_log-4119226e2e64e6d1c27d78465d578508.png";